import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/$videoTypeId/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/record-and-send/video-types/$videoTypeId/videos', params });
	},
});
